import { createSlice } from '@reduxjs/toolkit';

export const appIsCheck = createSlice({
  name: 'appIsCheck',
  initialState: {
    data: false,
  },

  reducers: {
    setAppIsCheck: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAppIsCheck } = appIsCheck.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getAppIsCheck = (state) => state.appIsCheck.data;

export default appIsCheck.reducer;
